import { useQuery } from '@tanstack/react-query';
import { getStoreTypes, supportQueryKeys } from '../../api';
import { SelectOption } from '../../types/option';

export type UseStoreTypeOptionsResult = {
  options: SelectOption[];
  loading: boolean;
  error: string | undefined;
  refetch: () => void;
};

export function useStoreTypeOptions(): UseStoreTypeOptionsResult {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: supportQueryKeys.storeTypes,
    queryFn: ({ signal }) => getStoreTypes(signal),
  });

  return {
    options: data ?? [],
    loading: isLoading,
    error: isError ? 'Não foi possível carregar os tipos de loja' : undefined,
    refetch: () => {
      void refetch();
    },
  };
}
